import React, { useState } from "react";
import "../../Styles/Pages/auth_superadmin.css";
import {
  Button,
  Grid,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { instance, updateToken } from "../../utils/api";
import farm from "../../Assets/login-page-logo.svg";
import login from "../../Assets/loginpage.svg";

const Superadmin_login = ({ setTriggerRefresh }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = () => {
    setShowPassword(!showPassword);
  };

  //loginsuperadmin usestates define
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  //validation for loginsuperadmin
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const validateForm = () => {
    let isValid = true;

    //email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!emailRegex.test(email.toString().trim())) {
      setEmailError("Invalid email format");
      isValid = false;
    } else {
      setEmailError("");
    }

    // password validation
    if (!password) {
      setPasswordError("password is required");
      isValid = false;
    } else {
      setPasswordError("");
    }
    return isValid;
  };

  //login functionality for superadmin
  const loginsuperadmin = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      setLoading(true);
      const response = await instance.post(
        "superAdmin/login",
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        localStorage.setItem("token", response?.data?.token);
        localStorage.setItem("role", response?.data?.role);
        updateToken(response?.data?.token);
        setTriggerRefresh((prev) => prev + 1);
        navigate("/superadmin/Dashboard");
        toast.success(response?.data?.message);
      } else {
        toast.error(
          "Login failed. Unexpected status: " + response?.data?.message
        );
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false)
    }
  };

  //click on enter button login to dashboard function
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      loginsuperadmin();
    }
  };

  return (
    <React.Fragment>
      <section className="admin_signup">
        <div className="signup_image">
          <img src={farm} alt="signup_image" />
        </div>
        <div className="signup">
          <div className="login signup_content">
            <Grid container direction="column" spacing={2}>
              <Typography variant="h2">
                <img src={login} />
              </Typography>
              <Typography>Login to access all your data</Typography>
              <Grid item>
                <TextField
                  type="email"
                  label="Enter Your Email"
                  placeholder="Email Address"
                  variant="outlined"
                  // autoComplete='off'
                  required
                  fullWidth
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value.trim().toLowerCase());
                    setEmailError("");
                  }}
                  error={Boolean(emailError)}
                />
                <FormHelperText error={Boolean(emailError)}>
                  {emailError}
                </FormHelperText>
              </Grid>
              <Grid item>
                <TextField
                  label="Password"
                  variant="outlined"
                  placeholder="Password"
                  // autoComplete='off'
                  required
                  fullWidth
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value.trim());
                    setPasswordError("");
                  }}
                  error={Boolean(passwordError)}
                  type={showPassword ? "text" : "password"}
                  onKeyDown={handleKeyDown} // Attach handleKeyDown here
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? (
                            <VisibilityIcon />
                          ) : (
                            <VisibilityOffIcon />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <FormHelperText error={Boolean(passwordError)}>
                  {passwordError}
                </FormHelperText>
              </Grid>
              <Grid item>
                <div className="forgot-password">
                  <Typography>
                    <NavLink
                      style={{ textDecoration: "none", color: '#78c144', fontWeight: 'bold' }}
                      to="/superadmin/superAdminForgotPassword"
                    >
                      Forgot Password
                    </NavLink>
                  </Typography>
                </div>
              </Grid>
              <Grid item>
                <Button variant="contained" onClick={loginsuperadmin}>
                  {loading ? <CircularProgress size={20} sx={{ color: "white" }} /> : "Login"}
                </Button>
              </Grid>
            </Grid>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Superadmin_login;
